<template>
    <div>
        <div class="row mb-5">
            <h6 class="col-11 ml-2 mt-3">分享代理用户列表:</h6>
            <div class="col-12 pb-1">
                <el-table ref="multipleTable" :data="tableData">
                    <el-table-column prop="username" label="用户名" width="150">
                    </el-table-column>

                    <el-table-column prop="email" label="邮箱">
                    </el-table-column>

                    <el-table-column prop="order_amount" label="订单金额">
                    </el-table-column>

                    <el-table-column prop="payed_amount" label="支付金额">
                    </el-table-column>

                    <el-table-column prop="status" label="状态" width="70">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 1" type="success">可用</el-tag>
                            <el-tag v-if="scope.row.status === 0" type="danger">停用</el-tag>
                            <el-tag v-if="scope.row.status === 2">过期</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="create_time" label="创建日期" :formatter="tableDateFormat">
                    </el-table-column>

                    <el-table-column prop="update_time" label="更新时间" :formatter="tableDateFormat">
                    </el-table-column>
                </el-table>
            </div>


            <div class="sh-20"></div>

            <el-pagination background layout="prev, pager, next" :pager-count="11" @current-change="pageChange"
                :current-page="page" :total="count">
            </el-pagination>
        </div>
        <footerPage></footerPage>
    </div>
</template>
  
<script>
import footerPage from '@/components/userInfo/footer'
export default {
    name: "proxyDetail",
    components: { footerPage },
    data () {
        return {
            page: 1,
            tableData: [],
            count: 10,
            editionOptions: [
                { label: '个人/企业版', value: 1 },
                { label: '4K视频不限速版', value: 2 },
                { label: 'Pro专业版', value: 3 }
            ]
        }
    },
    computed: {
        comValue () {
            return (obj, status) => {
                return this.getLabelByValue(obj, status);
            }
        },
    },
    created () {
        this.getDetailData(1)
    },
    mounted () {
    },
    methods: {
        getLabelByValue (arr, value) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].value === value) {
                    return arr[i].label;
                }
            }

            return null; // 如果未找到对应的label，则返回null或其他适合的默认值
        },
        pageChange (p) {
            this.getDetailData(p)
        },
        getDetailData (page, username, email) {
            this.page = page
            this.axios.get('/user/agentOrder', {
                params: {
                    userId: this.$route.params.userId,
                    page: page,
                    orderStatus: '',
                    orderId: '',
                    username: username || '',
                    email: email || ''
                }
            }).then(resp => {
                var data = resp.data.data
                this.tableData = data.datas;
                this.count = data.count
            }).catch(() => {
                this.$message.error('哦，请求出错');
            });
        }
    }
}
</script>
  
<style scoped>
@media (min-width: 300px) and (max-width: 767px) {}

body {
    position: relative;
    min-height: 100%;
    box-sizing: border-box;
    padding-bottom: 125px;
}
</style>